module.exports = __webpack_public_path__ + "static/img/gbLogo.e690d35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gbLogo.png
// module id = 2ASG
// module chunks = 24